import axios from "axios";

const state = {
  sms_settings: {},
};

const getters = {
  sms_settings: (state) => state.sms_settings,
};

const actions = {
  async get_sms_settings({ commit }) {
    const response = await axios.get("sms_settings");
    commit("SET_SMS_SETTINGS", response.data);
    return response.data;
  },

  async update_sms_settings({ commit }, settings) {
    const response = await axios.put("sms_settings", settings);
    commit("SET_SMS_SETTINGS", response.data);
    return response.data;
  },

  async send_test_sms(context, phone) {
    const response = await axios.post("sms_test", { phone });
    return response.data;
  },
};

const mutations = {
  SET_SMS_SETTINGS(state, settings) {
    state.sms_settings = settings;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
